/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Description_Export_Preset_Load_TitleInputs */



/**
* | output |
* | --- |
* | "Load Audio Description Export Preset" |
*
* @param {Audio_Description_Export_Preset_Load_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_description_export_preset_load_title = /** @type {((inputs?: Audio_Description_Export_Preset_Load_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Description_Export_Preset_Load_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Charger un préréglage d'exportation de description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("Audiobeschreibung laden Voreinstellung exportieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Carica preimpostazione di esportazione della descrizione audio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Загрузить аудиоописание Экспорт предустановки")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cargar ajuste preestablecido de exportación de descripción de audio")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("加载音频描述导出预设")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オーディオ説明エクスポートプリセットを読み込む")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ऑडियो विवरण निर्यात प्रीसेट लोड करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Carregar predefinição de exportação de audiodescrição")
	return /** @type {LocalizedString} */ ("Load Audio Description Export Preset")
});